import React from 'react';
import { Link } from 'react-router-dom';
import { Compass } from 'lucide-react';

const NotFound = () => {
  return (
    <div
      className="flex items-center justify-center py-20 px-4"
      style={{ minHeight: '60vh', backgroundColor: '#F9FAFB' }}
    >
      <div className="text-center max-w-md">
        <div className="flex justify-center mb-6">
          <Compass
            className="w-16 h-16"
            style={{ color: '#bb9749' }}
            strokeWidth={1.5}
          />
        </div>
        <h1
          className="mb-3"
          style={{
            fontSize: '24px',
            fontWeight: 700,
            color: '#1a1a2e',
          }}
        >
          Page not found
        </h1>
        <p
          className="mb-8"
          style={{
            fontSize: '15px',
            lineHeight: 1.6,
            color: '#6B7280',
          }}
        >
          The link may be incorrect, or this page has moved.
        </p>
        <Link
          to="/"
          className="inline-block px-6 py-3 rounded-lg font-semibold transition-opacity hover:opacity-90"
          style={{
            backgroundColor: '#bb9749',
            color: '#ffffff',
          }}
        >
          Back to home
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
